// src/router.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import PainelNoticias from '../views/PainelNoticias.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/bi/inicio'
  },
  {
    path: '/bi/:link',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/painel-noticias',
    name: 'PainelNoticias',
    component: PainelNoticias
  }
]

const router = new VueRouter({
  mode: 'history', // Se usar o modo "history" como mencionado antes, ajuste as configurações no servidor
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('busca/loadFromLocalStorage')
  const hasToken = store.getters['busca/filial']?.token

  if (to.path !== '/login' && !hasToken) {
    next('/login')
  } else {
    next()
  }
})

export default router
